// services/orderMutationApiSlice.js
import { apiSlice } from "../apiSlice";

export const orderMutationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateOrder: builder.mutation({
      query: ({ id, patchData }) => ({
        url: `orders/${id}`,
        method: "PATCH",
        body: patchData,
      }),
      // Invalidate the specific order tag so queries refetch
      invalidatesTags: (result, error, { id }) => [{ type: "Orders", id }],
    }),
  }),
});

export const { useUpdateOrderMutation } = orderMutationApiSlice;
